export var numericBreaks = {
    desktop: 1344,
    tablet: 876,
};
var customBreakPoints = {
    desktopBreakpoint: "(max-width: ".concat(numericBreaks.desktop - 1, "px)"),
    tableBreakpoint: "(max-width: ".concat(numericBreaks.tablet - 1, "px)"),
    minWidthTabletBreakpoint: "(min-width: ".concat(numericBreaks.tablet, "px)"),
    minWidthDesktopBreakpoint: "(min-width: ".concat(numericBreaks.desktop, "px)"),
};
export default customBreakPoints;
